import apiClient from './apiClient';

export const uploadResume = async (formData) => {
  const { data } = await apiClient.post('/api/resumes', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
};

export const getResumes = async () => {
  const { data } = await apiClient.get('/api/resumes');
  return Array.isArray(data) ? data : [];
};

export const deleteResume = async (id) => {
  await apiClient.delete(`/api/resumes/${id}`);
};

